export default {
  tab: 'Registration requests',
  subtitle: 'People who asked to join the organization through its public form.',
  loadFailed: 'The requests could not be loaded.',
  loadMore: 'Show more',
  filters: {
    label: 'Request status',
    pending: 'Pending',
    approved: 'Approved',
    rejected: 'Rejected',
    all: 'All',
  },
  status: {
    pending: 'Pending',
    approved: 'Approved',
    rejected: 'Rejected',
    decided: 'Decided',
  },
  table: {
    applicant: 'Applicant',
    submittedAt: 'Sent on',
    status: 'Status',
    workspace: 'Workspace',
    joined: 'Joined',
    invited: 'Invitation sent',
    open: 'View the request',
  },
  empty: {
    pending: 'No pending request',
    approved: 'No approved request',
    rejected: 'No rejected request',
    all: 'No request yet',
    description: 'Requests sent through the public form appear here.',
  },
  form: {
    title: 'Public form',
    open: 'Open',
    closed: 'Closed',
    openDescription: 'Anyone with this address can ask to join the organization.',
    closedDescription: 'The form takes no request. The ones already received stay here.',
    noAddress: 'No public address can be named for this organization.',
    copy: 'Copy the address',
    copied: 'Address copied to the clipboard',
    copyFailed: 'The address could not be copied',
    settings: 'Form settings',
    loadFailed: 'The form settings could not be loaded.',
  },
  settings: {
    title: 'Form settings',
    enabled: 'Form open',
    enabledHint:
      'Closed, its address answers as if the organization had no form. The requests already received still wait for a decision.',
    schema: 'Extra questions',
    schemaNone: 'None: e-mail address and name only',
    schemaFields: 'no question | {count} question | {count} questions',
    schemaMissing: 'A schema that is no longer available',
    schemaHint:
      'The questions come from one of the organization\'s "registration request" metadata schemas, written by the Videas team.',
    termsUrl: 'Terms page',
    termsUrlHint: 'When set, the applicant must tick a box accepting these terms. Leave it empty to ask for nothing.',
    saved: 'Form settings saved',
    invalid: 'These settings were refused.',
    failed: 'The settings could not be saved.',
  },
  detail: {
    back: 'Back to requests',
    notFound: 'This organization has no request at this address.',
    submittedAt: 'Sent on {date}',
    locale: 'Form filled in {locale}',
    termsAccepted: 'Terms accepted on {date}',
    unverified: 'Unverified address: the invitation sent on approval is what confirms it.',
    answers: 'Answers',
    noAnswers: 'The form asked no other question.',
    yes: 'Yes',
    no: 'No',
    opensInNewTab: 'Opens in a new tab',
    decision: 'Decision',
    approvedBy: 'Approved by {name} on {date}',
    approvedOn: 'Approved on {date}',
    rejectedBy: 'Rejected by {name} on {date}',
    rejectedOn: 'Rejected on {date}',
    decidedOn: 'Decided on {date}',
    workspace: 'Workspace',
    workspaceGone: 'The workspace no longer exists',
    joinedOn: 'Joined the organization on {date}',
    notJoined: 'Has not accepted the invitation yet',
    rejectionMessage: 'Message sent to the applicant',
    approve: 'Approve',
    reject: 'Reject',
  },
  approve: {
    title: 'Approve the request',
    where: 'Where should {name} land?',
    create: 'Create a new workspace',
    existing: 'Add to an existing workspace',
    createDenied:
      'Only a role that can create workspaces and manage every workspace can create one here: nobody gets a seat in the new workspace, you included, and it must stay reachable.',
    name: 'Name of the new workspace',
    createHint:
      'Nobody sits in it until {name} accepts the invitation. Roles that manage every workspace can reach it.',
    pick: 'Workspace',
    noWorkspace: 'No workspace you can invite anyone to',
    noMatch: 'No workspace matches this search',
    role: 'Role in the workspace',
    answers: "The applicant's answers",
    invitation:
      'An invitation will be sent to {email}. Accepting it, the person joins the organization as a member, with this role in the workspace.',
    confirm: 'Approve and invite',
    success: 'Request approved: an invitation was sent to {email}',
  },
  reject: {
    title: 'Reject the request',
    notify: 'Tell the applicant by e-mail',
    notifyOff:
      'Nobody will be told. That is the way for an address that is already a member, once you have seated them in a workspace.',
    message: 'Message (optional)',
    messageHint: 'Attached to the e-mail and kept with the request.',
    confirm: 'Reject the request',
    success: 'Request rejected',
    successNotified: 'Request rejected: {email} will be told by e-mail',
  },
  errors: {
    network: 'The server cannot be reached. Try again.',
    invalid: 'This choice is not valid.',
    forbidden: 'You do not have the permissions this needs.',
    gone: 'This request or this workspace no longer exists.',
    conflict: 'The request could not be decided.',
    rateLimited: 'Too many invitations were sent recently. Try again later.',
    unavailable: 'E-mail is not available: the invitation cannot be sent.',
    generic: 'Something went wrong.',
  },
}
